import React from 'react';

import { Container, Menu } from 'semantic';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import {
  CHARGING_STATIONS_POLICIES_AND_GROUPS_CHARGING_GROUPS_ROUTE,
  CHARGING_STATIONS_POLICIES_AND_GROUPS_CHARGING_POLICIES_ROUTE,
  CHARGING_STATIONS_POLICIES_AND_GROUPS_CUSTOMER_GROUPS_ROUTE,
} from 'subdomains/cpo/router/routes';
import { FeatureFlags } from 'contexts/features';
import { FeatureFlag } from 'components';

type Props = {
  children: React.ReactNode;
};

export function GroupsAndPolicies({ children }: Props) {
  const { t } = useTranslation();

  return (
    <FeatureFlag feature={FeatureFlags.PoliciesAndGroups}>
      <Container>
        <Menu pointing secondary>
          <Menu.Item
            as={NavLink}
            to={CHARGING_STATIONS_POLICIES_AND_GROUPS_CHARGING_POLICIES_ROUTE}
            exact
            name={t(
              'policiesAndGroups.menu.chargingPolicies',
              'Charging Policies'
            )}
          />
          <Menu.Item
            exact
            as={NavLink}
            to={CHARGING_STATIONS_POLICIES_AND_GROUPS_CUSTOMER_GROUPS_ROUTE}
            name={t('policiesAndGroups.menu.customerGroups', 'Customer Groups')}
          />
          <Menu.Item
            exact
            as={NavLink}
            to={CHARGING_STATIONS_POLICIES_AND_GROUPS_CHARGING_GROUPS_ROUTE}
            name={t('policiesAndGroups.menu.chargingGroups', 'Charging Groups')}
          />
        </Menu>

        {children}
      </Container>
    </FeatureFlag>
  );
}
